import { formatGameTime, isDelayed } from '@sportal365/smp-widget-utils';
import { FINISHED, INTERRUPTED, LIVE, NOT_STARTED } from '../../../../packages/constants/statusTypes';
import { INormalizedLivescoreMatchData, ITeamWinnerForm } from '../types';
import { INormalizedFootballGameData, IOddsV2 } from '../../../../packages/types/common';

// this conditional logic is related with status changes (https://media-platform.atlassian.net/browse/SFE-5320)
export const getMatchColorAndStatus = (
  match:
    | INormalizedLivescoreMatchData
    | {
        info?: INormalizedFootballGameData;
        teamWinnerForm?: ITeamWinnerForm;
        odds?: IOddsV2;
      },
  isBetweenTeams: boolean,
) => {
  const isInterruptedMatchBetweenTeams = match?.info?.matchStatus?.type === INTERRUPTED && isBetweenTeams;
  const isPostponedOrCanceled = isDelayed(match?.info?.matchStatus?.type);

  let result, color;
  if (
    match?.info?.matchStatus?.type === LIVE ||
    match?.info?.matchStatus?.type === FINISHED ||
    match?.info?.matchStatus?.type === NOT_STARTED
  ) {
    result = match?.info?.status;
  } else if (isPostponedOrCanceled && isBetweenTeams) {
    result = '-';
  } else if (isInterruptedMatchBetweenTeams) {
    result = `${match?.info?.homeTeamScore} - ${match?.info?.awayTeamScore}`;
  } else if (isBetweenTeams) {
    result = formatGameTime(match?.info?.kickOffTime?.toString());
  } else {
    result = match?.info?.matchStatus?.shortName;
  }

  if (isInterruptedMatchBetweenTeams) {
    color = 'var(--colors-gray7)';
  } else if (isBetweenTeams && isPostponedOrCanceled) {
    color = 'var(--colors-hiContrast)';
  } else {
    color = 'auto';
  }

  return { status: result, color };
};
